export default class Cookie {
  static get(name: string): string {
    return new Map(
      document.cookie.split(';').map((cookie) => {
        const [key, value] = cookie.split('=');
        return [key.trim(), decodeURIComponent(value)];
      }),
    ).get(name)!;
  }
}
